import { NavLink } from 'react-router'
import { useMyClub } from '../../app/hooks/UseMyClub.ts'

export default function LandingCTA() {
  const { userLoaded, myClubPath } = useMyClub()
  const myClubHref = userLoaded ? myClubPath : undefined

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Start with your next meeting
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
            Set up in minutes, share one link, and watch this week&apos;s roles
            fill themselves
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-y-4 sm:flex-row sm:gap-x-6 sm:gap-y-0">
            {myClubHref ? (
              <NavLink
                data-testid="go-to-my-club-link"
                to={myClubHref}
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Go to my club
              </NavLink>
            ) : (
              <NavLink
                to="/register-club"
                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Start your club free
              </NavLink>
            )}
            <NavLink
              to="/clubs"
              className="text-sm font-semibold leading-6 text-gray-900">
              See a real club&apos;s live schedule{' '}
              <span aria-hidden="true">→</span>
            </NavLink>
          </div>
          <p className="mt-6 text-sm leading-6 text-gray-500">
            Free to start · No credit card · Nothing to install
          </p>
        </div>
      </div>
    </div>
  )
}
